import { toast } from "react-toastify";
import {
  fetchItemsRequest,
  fetchItemsSuccess,
  fetchItemsFailure,
} from "./reducer";
import { GET_ITEMS } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getItems =
  (first, offset) => async (dispatch) => {
    dispatch(fetchItemsRequest());

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        GET_ITEMS(first, offset),
        "GET"
      );

      if (response?.error) {
        dispatch(fetchItemsFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchItemsSuccess(response));
      }
    } catch (error) {
      dispatch(fetchItemsFailure("Something went wrong"));
      toast.error("Something went wrong");
    }
  };